const genders = ["Male", "Female", "Other"];
const documentTypes = ["PASSPORT", "ID_CARD"];

export const DropDowns = {
    genders,
    documentTypes,
}